function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleRestriction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 1080 1080",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1400 980"
    },
    width: "1080px",
    height: "1080px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 1080,
    height: 1080,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(47.321418762207024, 0, 0, 47.321418762207024, 4.131643295288085, 166.87663269042966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.587 15.2466C16.1029 15.7624 16.1029 16.5983 15.587 17.1133C15.0712 17.6291 14.2354 17.6291 13.7204 17.1133C13.2045 16.5974 13.2045 15.7616 13.7204 15.2466C14.2362 14.7308 15.072 14.7308 15.587 15.2466",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41998 15.2467C6.93581 15.7625 6.93581 16.5983 6.41998 17.1133C5.90414 17.6292 5.06831 17.6292 4.55331 17.1133C4.03831 16.5975 4.03748 15.7617 4.55331 15.2467C5.06914 14.7317 5.90414 14.7308 6.41998 15.2467",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 16.1799H2.50008C2.04008 16.1799 1.66675 15.8066 1.66675 15.3466V10.8333",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83325H16.1025C16.4433 5.83325 16.75 6.04075 16.8758 6.35742L18.2142 9.70242C18.2925 9.89909 18.3333 10.1091 18.3333 10.3208V15.2774C18.3333 15.7374 17.96 16.1108 17.5 16.1108H15.9742",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 16.1833H6.80835",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 11.6666H15V8.33325H17.6667",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 3.33329H5.83341",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 5.83329H4.16675",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50008 8.33329H1.66675",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 3.33325H11.6667C12.1267 3.33325 12.5001 3.70659 12.5001 4.16659V12.4999H1.66675",
    stroke: "#0B907B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.157109260559082 8.646674156188965 L 9.157109260559082 8.646674156188965",
    style: {
      fill: "rgb(177, 21, 26)",
      fillOpacity: 0,
      stroke: "rgb(11, 144, 123)",
      strokeOpacity: 1,
      strokeWidth: 1.5,
      paintOrder: "stroke"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.9688833117872124, 0, 0, 3.9688833117872124, -1717.7606771979265, -166.9887535351439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M652,46c27.6,0,50,22.4,50,50s-22.4,50-50,50s-50-22.4-50-50S624.4,46,652,46z",
    style: {
      fill: "rgb(237, 28, 35)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.712377071380615, 0, 0, 2.712377071380615, -532.4279174804686, -1608.4772949218748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 562.5999755859375 646.9000244140625 L 545.5999755859375 629.9000244140625 L 518.7000122070312 656.7000122070312 L 491.8999938964844 629.9000244140625 L 474.8999938964844 646.9000244140625 L 501.70001220703125 673.7999877929688 L 474.8999938964844 700.5999755859375 L 491.8999938964844 717.5999755859375 L 518.7000122070312 690.7999877929688 L 545.5999755859375 717.5999755859375 L 562.5999755859375 700.5999755859375 L 535.7999877929688 673.7999877929688 Z",
    className: "st0",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleRestriction);
export default __webpack_public_path__ + "static/media/vehicle-restriction.c57decb3596136740b7352d50e156f67.svg";
export { ForwardRef as ReactComponent };